import React from "react";
import { Wrapper, HeroButton, CheckList, CheckItem, CheckIcon } from "./styles";
import { FaCheck } from "react-icons/fa";

export default function PersonalizedAI({
  toggleQrModal,
  title,
  subtitle,
  description,
  buttonText,
}) {
  const items = [
    "Atendimento inteligente com IA treinada",
    "Análise automatizada de dados",
    "Monitoramento de segurança em tempo real",
    "Integração com seus sistemas e plataformas atuais",
  ];
  return (
    <Wrapper>
      <div className="text-wrapper">
        <div className="Title">{title}</div>
        <div className="DescriptionSubtext">{description}</div>
        <CheckList>
          {items.map((item, idx) => (
            <CheckItem key={idx}>
              <CheckIcon>
                <FaCheck />
              </CheckIcon>
              {item}
            </CheckItem>
          ))}
        </CheckList>{" "}
        <div className="Subtitle">{subtitle}</div>
        {buttonText && (
          <HeroButton onClick={toggleQrModal}>{buttonText}</HeroButton>
        )}
      </div>
      <img src="assets/dark/abstract-form.png" width={"45%"} alt="forma asbtrata tecnológica"/>
    </Wrapper>
  );
}
